import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const translationPath = (baseUrl: string, locale: string) =>
  `${baseUrl}assets/locale/productWidget/productWidget_${locale}.json`;

export const FormFactor = {
  Desktop: 'Desktop',
  Mobile: 'Mobile',
  Tablet: 'Tablet',
} as const;

export type FormFactorType = (typeof FormFactor)[keyof typeof FormFactor];

export const origin = 'product-widget';
export const DEFAULT_IMAGE_DEFAULT_SIZE = '80';
export const SPECS = {
  ...SdkSpecs,
  EDITOR_OOI: 'specs.stores.EditorOOI',
  SHOULD_USE_NEW_DEFAULT_PRODUCT_IMAGE: 'specs.stores.UseNewDefaultProductImage',
  USE_EXPERIMENTS_FROM_PLATFORM: 'specs.stores.UseExperimentsFromPlatformFlowApiLegacyProjects',
};

export const MULTILINGUAL_TO_TRANSLATIONS_MAP = {
  NAVIGATE_TO_PRODUCT_PAGE_BUTTON: 'PRODUCT_WIDGET_BUTTON_TEXT',
  ADD_TO_CART_BUTTON: 'PRODUCT_WIDGET_BUTTON_TEXT',
  OUT_OF_STOCK: 'PRODUCT_WIDGET_BUTTON_OOS_TEXT',
};
